export default "__VITE_PUBLIC_ASSET__d6ae9c53__"